<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'forum', params: {id: 1}}"
    >{{$t('news.template.proposal.votingProvided.p1')}}</router-link>
    {{$t('news.template.proposal.votingProvided.p2')}}
    {{news.textParams[0]}}
    {{$t('news.template.proposal.votingProvided.p3')}}
    {{news.textParams[1]}}.
    {{$t('news.template.proposal.votingProvided.p4')}}
  </div>
</template>
